import { useState, useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import { useDispatch } from 'react-redux';
import { CONNECTION_STATE_CHANGE } from 'aws-amplify/api';
import { Hub } from 'aws-amplify/utils';
import { toast } from 'react-toastify';

// grahql
import { gqlSubscribeFilteredJobService } from '../graphql/subscription/subscribeFilteredJobService';

// reducers
import { mutateJobSubscription } from '../stores/jobs';

// enum
import { 
  ENUM_JOB_STATUS_TECH_ASSIG,
  ENUM_JOB_STATUS_JOB_INIT,
  ENUM_JOB_STATUS_JOB_NAV_CREATED,
  ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
  ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED,
} from '../utilities';

export const RealtimeJobsProvider = (props) => {

  // hooks
  const dispatch = useDispatch();

  // states
  const [mounted, setMounted] = useState(false);

  const subscribeJobs = () => {
    try {
      const graphQLClient = generateClient();

      const subscription = graphQLClient
        .graphql({ 
          query: gqlSubscribeFilteredJobService,
          variables: {
            filter: JSON.stringify({
              stage: {eq: 'OPEN'}
            })
          }
        })
        .subscribe({
          next: async({ data }) => {
            console.log('providers.realtime.jobs@subscribeJobs#subscribe', 'data', data);
            const job = data.subscribeFilteredJobService;

            const interestedStatus = [
              ENUM_JOB_STATUS_TECH_ASSIG,
              ENUM_JOB_STATUS_JOB_INIT,
              ENUM_JOB_STATUS_JOB_NAV_CREATED,
              ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
              ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
              ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
              ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED,
            ];
            if (!interestedStatus.indexOf(job.status) > -1) dispatch(mutateJobSubscription(job));

            if (job.status === 'ENUM_JOB_STATUS_TECH_ASSIG') {
              toast.success('New job order is created and has been paid');
            }
          },
          error: (error) => {
            console.warn('providers.realtime.jobs@subscribeJobs#subscribe', error);
          }
      });

      Hub.listen('api', (data) => {
        const { payload } = data;
        if (payload.event === CONNECTION_STATE_CHANGE) {
          const connectionState = payload.data.connectionState;
          console.log('providers.realtime.jobs@subscribeJobs', connectionState);
        }
      });
    } catch (err) {
      console.error('providers.realtime.jobs@subscribeJobs', err);
    } 
  }

  useEffect(() => {
    // sanity check
    if (!mounted) return;

    subscribeJobs();

  }, [mounted])

  useEffect(() => {
    setMounted(true);
  }, [])

  return null;
}